interface Props {
  variant: 'error' | 'empty'
  size?: number
  className?: string
}

export default function EmptyIllustration({ variant, size = 96, className }: Props) {
  const beamColor = variant === 'error' ? '#ef4444' : 'var(--accent)'
  const beamOpacity = variant === 'error' ? 0.85 : 0.55

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      {/* ground / water */}
      <path d="M0 78h96v18H0z" fill="currentColor" opacity="0.04" />
      <path
        d="M4 80c8-2 12 2 20 2s12-4 20-4 12 4 20 4 12-2 20-2 8 0 8 0"
        stroke="currentColor"
        strokeOpacity="0.18"
        strokeWidth="1.3"
        strokeLinecap="round"
      />

      {/* lighthouse base */}
      <path
        d="M34 80l4-36h20l4 36H34z"
        stroke="currentColor"
        strokeOpacity="0.45"
        strokeWidth="1.5"
        fill="rgba(255,255,255,0.02)"
      />
      <path
        d="M37 64h22M38 56h20"
        stroke="currentColor"
        strokeOpacity="0.35"
        strokeWidth="1.3"
        strokeLinecap="round"
      />

      {/* lantern room */}
      <rect
        x="40"
        y="32"
        width="16"
        height="12"
        rx="1.5"
        stroke="currentColor"
        strokeOpacity="0.5"
        strokeWidth="1.5"
        fill="rgba(255,255,255,0.02)"
      />
      <rect
        x="42"
        y="22"
        width="12"
        height="10"
        rx="2"
        stroke="currentColor"
        strokeOpacity="0.5"
        strokeWidth="1.5"
        fill="rgba(255,255,255,0.02)"
      />
      <circle cx="48" cy="27" r="2" fill={beamColor} opacity={beamOpacity} />

      {/* beam */}
      {variant === 'empty' ? (
        <g opacity={beamOpacity}>
          <path
            d="M54 24l24-6M54 28l26 0M54 32l24 6"
            stroke={beamColor}
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeDasharray="2 4"
          />
        </g>
      ) : (
        <g opacity={beamOpacity}>
          {/* zig-zag fault line for error state */}
          <path
            d="M54 26l8-3-3 7 9-2-4 8"
            stroke={beamColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <circle cx="74" cy="34" r="2" fill={beamColor} />
        </g>
      )}
    </svg>
  )
}
